import { useLingui } from '@lingui/react/macro';

import { DesktopEntityFilter } from '@/components/SharedFilters/EntityFilter/DesktopEntityFilter';
import IconPlace from '@/icons/Place.svg';

import { useFilters } from '../FiltersState';

export const FiltersDestination = ({ tag }: { tag?: boolean }) => {
  const { t } = useLingui();

  const {
    destinations: { destinations, setDestinations },
  } = useFilters();

  const selectedDestinationsCount = destinations.length;

  return (
    <DesktopEntityFilter
      selectedEntities={destinations}
      setSelectedEntities={setDestinations}
      traits={['store', 'workshop']}
      tag={tag}
      label={t({ id: 'shipments.filters.destination.label', message: 'Destination' })}
      searchPlaceholder={t({
        id: 'shipments.filters.destination.search.label',
        message: 'Search destinations',
      })}
      icon={<IconPlace end />}
      tagSelectedCountLabel={t({
        id: 'shipments.filters.destination.multiple',
        message: `${selectedDestinationsCount} destinations`,
      })}
    />
  );
};
